// extracted by mini-css-extract-plugin
export default {"box":"marginChart_box__Ydwth","header":"marginChart_header__cvMRh","heading":"marginChart_heading__Asz9d","dropdown":"marginChart_dropdown__pLvwt"};